import React, { Component } from "react";
import Notification from "../shared/notification";
import style from "../login/login.module.css";
import * as apiEndPoints from "../shared/apiPaths";
import * as routes from "../shared/routes";
import axios from "axios";
import { getErrorMessage } from "../shared/utils";
import * as Messages from "../shared/messages";
import analytics from "../shared/analytics"

class RecoverPassword extends Component {
  constructor(props) {
    super(props);
    analytics.pageView();
    this.state = { email: "" };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.formRef.current.addEventListener("submit", e => this.submitHandler(e));
  }

  usernameChangedHandler = event => {
    this.setState({ email: event.target.value });
  };

  submitHandler = event => {
    const url = window.ENV.LOGIN_API_ROOT + apiEndPoints.RECOVER_PASSWORD;
    const currentUrl = window.location.href.toString()
    const rootUrl = currentUrl.substring(0, currentUrl.lastIndexOf(routes.recoverPassword))
    axios
      .post(url, {
        email: this.state.email,
        rootUrl: rootUrl
      })
      .then(response => {
        this.onSuccess();
      })
      .catch(error => {
        const status = error.response ? error.response.status : 0;
        this.onFailure(getErrorMessage(error), status);
      });
  };

  onSuccess = () => {
    this.props.history.push(routes.recoverConfirmation);
  }

  onFailure = (message, status) => {
    const messageToDisplay = status === 403 ? Messages.multipleAccountForAnEmail : message;
    Notification.showNotification("danger", messageToDisplay);
  }

  render() {
    let logoUrl = "https://cdn.svc.oneadvanced.com/mosaic/2.0.0/img/logo.svg";
    let logoAlt = "Advanced"
    if (process.env.NODE_ENV === 'production') {
      logoUrl = window.applicationIcon;
      logoAlt = window.applicationName;
    }
    return (
      <React.Fragment>
        <mosaic-page class={style.mosaicpage}>
          <mosaic-content-container>
            <mosaic-main-container fluid>
              <div className={style.pageBgOverlay} />
              <mosaic-card class={style.card}>
                <mosaic-card-body class="pb-0">
                  <div className={style.logo}>
                    <img
                      src={logoUrl}
                      alt={logoAlt}
                    />
                  </div>
                  <h1 className={style.appName}>
                    <span><mosaic-translation Key="app.company.name"></mosaic-translation></span>
                  </h1>
                  <h2 className={style.contentTitle}>Forget your password?</h2>
                  <div className="content">
                    <p className="strapline">
                      Enter the email address you used when you joined and we’ll
                      send you instructions to reset your password.
                    </p>

                    <mosaic-form
                      ref={this.formRef}
                      class="form"
                      prevent-default
                      novalidate
                    >
                      <mosaic-email-input
                        name="email"
                        block
                        required
                        prepend
                        icon="user"
                        label="Email"
                        placeholder="Enter your email address"
                        onInput={this.usernameChangedHandler}
                        value={this.state.email}
                      />

                      <mosaic-form-actions>
                        <mosaic-button
                          color="primary"
                          icon="paper_plane"
                          class="btn-block"
                          submit
                          block
                        >
                          Send instructions
                        </mosaic-button>
                      </mosaic-form-actions>
                    </mosaic-form>
                  </div>
                </mosaic-card-body>
                <mosaic-card-footer class="p-0">
                  <div className={style.loginFooter}>
                    <small className={style.small}>&copy;2019 Advanced</small>
                  </div>
                </mosaic-card-footer>
              </mosaic-card>
            </mosaic-main-container>
          </mosaic-content-container>
        </mosaic-page>
      </React.Fragment>
    );
  }
}

export default RecoverPassword;
